import defaultAttributes from '../defaultAttributes';

const SignalZero = ['svg', defaultAttributes, [['path', { d: 'M2 20h.01' }]]];

export default SignalZero;
